const PRODUCT_IMG =
  'https://customer-assets.emergentagent.com/job_smart-living-18/artifacts/6j2kav5l_Window%20robo.jpeg';

const shineBotC2 = {
  slug: 'shinebot-c2',
  name: 'ShineBot C2',
  testid: 'shinebot',
  accent: 'cyan',
  breadcrumb: { label: 'Window Cleaning Robots', href: '/window-cleaning-robots' },
  brochureUrl:
    'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/n71l2hee_1.%20Harpalyk-Revolutionary%20Window%20Cleaning%20Robot.pdf',
  meta: {
    title: 'ShineBot C2 - Smart Window Cleaning Robot | ₹45,999 | Harpalyk',
    description:
      'Buy ShineBot C2 ⭐ AI window cleaning robot with 3000Pa suction, dual water spray, smart navigation (N/Z/N+Z paths), anti-fall frameless edge detection, ultra-soft mop, backup power & app control. Works on framed/frameless glass, mirrors & tiles. ₹45,999.',
    keywords:
      'ShineBot C2, window cleaning robot, automatic window cleaner India, glass cleaning robot, frameless glass robot, high-rise window cleaner, Harpalyk window robot',
    canonical: 'https://harpalyk.com/products/shinebot-c2',
  },
  schema: {
    name: 'Harpalyk ShineBot C2 Smart Window Cleaning Robot',
    description:
      'ShineBot C2 intelligent window cleaning robot with 3000Pa suction, dual water spray system, AI smart navigation (N/Z/N+Z paths), anti-fall frameless edge detection, ultra-soft microfiber mop, backup power and app + remote control. Works on framed/frameless glass, mirrors and tiles.',
    image: PRODUCT_IMG,
    category: 'Window Cleaning Robot',
    price: '45999',
    ratingValue: '4.7',
    reviewCount: '63',
  },
  hero: {
    gradient: 'from-slate-900 via-sky-900 to-cyan-900',
    badge: 'SHINEBOT · Intelligent Water Spray Window Robot',
    tagline: 'Luxurious Design. Spotless Results.',
    description:
      'An AI-driven smart window cleaning robot with a dual water spray system, powerful 3000Pa suction and advanced anti-fall safety — redefining window cleaning with innovation and elegance.',
    highlights: [
      { label: '3000 Pa Suction', icon: 'Zap' },
      { label: 'Anti-Fall Detection', icon: 'Shield' },
      { label: 'Dual Water Spray', icon: 'Droplets' },
      { label: 'Smart App Control', icon: 'Smartphone' },
    ],
    galleryAccent: 'cyan',
    galleryBadge: 'Window & Glass Robot',
  },
  overview: {
    heading: 'Redefining Window Cleaning with Innovation & Elegance.',
    sub: 'The ShineBot C2 is an intelligent, AI-driven device for automated, efficient window cleaning — combining a dual water spray system, robust suction and advanced anti-fall technology for spotless, worry-free results.',
    checklistTitle: 'Exquisite Details. Enjoy a Smart Life.',
    checklist: [
      'Dual intelligent water sprinkler for uniform wet mopping',
      '3000Pa suction for a secure grip on all glass surfaces',
      'Intelligent path planning with no missed dead corners',
      'Anti-fall sensors detect frameless edges and auto-retreat',
      'Works on framed/frameless glass, mirrors, tiles & marble',
      'Backup power, safety rope and power-failure protection',
      'Whisper-quiet operation with smart app & remote control',
    ],
    panelGradient: 'from-cyan-50 to-sky-50',
    stats: [
      { value: '3000 Pa', label: 'Suction Power' },
      { value: '6.5 m/min', label: 'Cleaning Speed' },
      { value: '1.5 kg', label: 'Lightweight' },
      { value: '72 W', label: 'Rated Power' },
      { value: '100 kg', label: 'Safety Rope' },
      { value: '4 Modes', label: 'Cleaning Paths' },
    ],
  },
  features: {
    heading: 'Powerful Features for Spotless Glass',
    items: [
      { icon: 'Zap', title: '3000 Pa Powerful Suction', description: 'Strong, stable suction for a secure grip on all glass surfaces, ensuring safe and reliable operation without slipping.' },
      { icon: 'Droplets', title: 'Dual Water Spray System', description: 'Double water spray mechanism with electronically controlled tank for uniform wet mopping and superior stain removal.' },
      { icon: 'Navigation', title: 'AI Smart Navigation', description: 'Intelligent path-planning algorithm with N, Z and N+Z patterns for thorough, high-coverage cleaning with no missed corners.' },
      { icon: 'Shield', title: 'Anti-Fall Safety Technology', description: 'High-precision opto-coupler sensors detect frameless edges in real time and automatically retreat to prevent falls.' },
      { icon: 'ScanLine', title: 'Frameless Edge Detection', description: 'High-precision opto-coupler + updated laser sensors make it suitable for both framed and frameless glass surfaces.' },
      { icon: 'Sparkles', title: 'Thicker Ultra-Soft Mop', description: 'High-speed rotating microfiber mops remove dirt effectively while caring delicately for the glass without damage.' },
      { icon: 'BatteryCharging', title: 'Multi Safety Protection', description: 'Backup power with power-failure protection, plus a safety rope rated for 100kg to keep the robot secure at all times.' },
      { icon: 'Volume2', title: 'Whisper Quiet Operation', description: 'Low-noise design keeps your environment peaceful while the robot works through your windows and mirrors.' },
      { icon: 'Smartphone', title: 'Smart App & Remote Control', description: 'Control, monitor and customise cleaning from your smartphone, or use the infrared handheld remote for instant control.' },
      { icon: 'Cpu', title: 'AI Intelligent Chip & Memory', description: 'A dedicated AI chip with smart memory remembers cleaning paths and supports fixed-point spot cleaning.' },
    ],
  },
  sections: [
    {
      type: 'split',
      label: 'Safety Technology',
      heading: 'Safer Cleaning with Anti-Fall & Smart Detection',
      desc: 'Built-in opto-coupler and laser sensors detect frameless edges in real time and automatically retreat, making window cleaning safer, more reliable, and worry-free.',
      itemIcon: 'Shield',
      items: [
        { title: 'Anti-fall sensors detect frameless edges and auto-retreat' },
        { title: 'Safety rope rated for 100kg for total fall protection' },
        { title: 'Backup power with power-failure protection keeps it secured' },
        { title: 'Gyro sensor maintains stable, accurate path tracking' },
        { title: 'Automatic wheel cleaning for consistent grip' },
      ],
      panel: {
        gradient: 'from-sky-600 to-cyan-700',
        title: 'Intelligent Path Planning',
        desc: 'High-coverage cleaning without leakage. Choose from four cleaning modes and let the ShineBot C2 work through every corner of your glass, then return to its start point automatically.',
        subClass: 'text-cyan-100',
        chips: ['Automatic Cleaning Mode', 'N-Path Cleaning Mode', 'Z-Path Cleaning Mode', 'N+Z Combined Path Mode'],
        chipIcon: 'Navigation',
        chipIconClass: 'text-cyan-200',
      },
    },
    {
      type: 'darkCards',
      label: 'Cleaning Performance',
      heading: 'Effortlessly Erase Every Stain',
      sub: 'Dual water spray, high-speed rotating microfiber mops and 3000Pa suction remove even stubborn stains — without damaging the glass surface.',
      cards: [
        { icon: 'Droplets', title: 'Dual Water Spray', desc: 'An electronically controlled, large-capacity tank enables automatic, uniform spraying for superior wet mopping — no frequent manual spraying needed.', badge: 'Auto Spraying' },
        { icon: 'Sparkles', title: 'Ultra-Soft Microfiber Mop', desc: 'Thicker, high-speed rotating mops remove dirt effectively while caring delicately for the glass, leaving a streak-free, spotless finish.', badge: 'No Glass Damage' },
        { icon: 'Wind', title: 'Erases Tough Stains', desc: 'Removes water and rain stains, dust, smog residue, bird droppings, ink, cosmetic and beverage stains and general pollution marks with ease.', badge: 'All Stain Types' },
      ],
      extraChips: [
        'Water & rain stains',
        'Dust, ash & smog residue',
        'Bird droppings',
        'Ink & cosmetic stains',
        'Toothpaste & beverage stains',
        'General dirt & pollution marks',
      ],
    },
    {
      type: 'itemGrid',
      variant: 'gradient',
      icon: 'Maximize2',
      label: 'Versatility',
      heading: 'Multi-Surface Application in Different Scenarios',
      sub: 'Easily applicable for various kinds of facades and smooth surfaces, with high cleaning coverage and no missed dead corners.',
      items: [
        'Framed & Frameless Glass',
        'Double / Vacuum Glass',
        'Bathroom & Vanity Mirrors',
        'Seamless Mirror Tile / Marble',
        'Smooth Ceramic Tiles',
        'Whole-House Windows',
      ],
    },
    {
      type: 'itemGrid',
      bg: 'gray',
      variant: 'white',
      icon: 'CheckCircle',
      label: "What's in the Box",
      heading: 'A Complete, Ready-to-Clean Kit',
      items: [
        'Window Cleaning Robot',
        'Power Adapter',
        'Safety Rope (100kg)',
        'Infrared Remote Control',
        'Microfiber Cleaning Cloth',
        'Water Injection Bottle',
        'Empty Spraying Bottle',
        'User Manual',
      ],
    },
  ],
  specs: {
    defaultTab: 'general',
    tabs: [
      { id: 'general', label: 'General' },
      { id: 'power', label: 'Power' },
      { id: 'cleaning', label: 'Cleaning' },
      { id: 'safety', label: 'Safety & Control' },
    ],
    data: {
      general: [
        { label: 'Model Name', value: 'ShineBot C2' },
        { label: 'Type', value: 'Smart Window Cleaning Robot' },
        { label: 'Suction Power', value: '3000 Pa' },
        { label: 'Dimensions', value: '215 × 215 × 80 mm' },
        { label: 'Weight', value: '1.5 kg' },
        { label: 'Noise Level', value: 'Whisper Quiet' },
      ],
      power: [
        { label: 'Rated Power', value: '72 W' },
        { label: 'Rated Voltage', value: '24 V' },
        { label: 'Adapter Input', value: '100-240V ~ 50/60Hz 1.5A' },
        { label: 'Adapter Output', value: '24V / 3A' },
        { label: 'Backup Battery Charging', value: '1 Hour' },
        { label: 'Power Failure Protection', value: 'Yes (UPS Backup)' },
      ],
      cleaning: [
        { label: 'Cleaning Speed', value: '6.5 m/min' },
        { label: 'Water System', value: 'Dual Intelligent Sprinkler' },
        { label: 'Mop', value: 'Thicker Ultra-Soft Microfiber' },
        { label: 'Cleaning Modes', value: 'Auto / N / Z / N+Z Path' },
        { label: 'Auto Return', value: 'Returns to Start Point' },
        { label: 'Fixed-Point Cleaning', value: 'Yes (Smart Memory)' },
      ],
      safety: [
        { label: 'Edge Sensors', value: 'High-Precision Opto-Coupler' },
        { label: 'Navigation Sensors', value: 'Updated Laser + Gyro Sensor' },
        { label: 'Anti-Fall', value: 'Real-Time Frameless Detection' },
        { label: 'Safety Rope', value: 'Rated 100 kg' },
        { label: 'Wheel Cleaning', value: 'Automatic' },
        { label: 'Control', value: 'Infrared Remote + Smart App' },
      ],
    },
  },
  contact: {
    heading: 'Ready for Crystal-Clear Windows?',
    sub: 'Upgrade to effortless, safe window cleaning with the ShineBot C2. Contact us today for pricing and availability.',
    gradient: 'from-cyan-600 to-sky-700',
  },
  faqs: [
    {
      question: 'Does the ShineBot C2 work on frameless glass safely?',
      answer:
        'Yes. High-precision opto-coupler sensors and updated laser sensors detect frameless edges in real time and the robot automatically retreats to prevent falls. A 100kg-rated safety rope and backup power provide additional protection, making cleaning safer, reliable and worry-free on both framed and frameless glass.',
    },
    {
      question: 'How powerful is the suction and will it slip?',
      answer:
        'The ShineBot C2 delivers 3000 Pa of suction for a strong, stable grip on all glass surfaces, ensuring safe, reliable operation without slipping — even on vertical windows and smooth surfaces.',
    },
    {
      question: 'What surfaces can it clean?',
      answer:
        'It cleans framed, frameless, double and vacuum glass, bathroom and vanity mirrors, seamless mirror tile/marble, smooth ceramic tiles and whole-house windows — easily erasing water stains, dust, smog residue, bird droppings, ink, cosmetic and beverage stains without damaging the surface.',
    },
    {
      question: 'How does it navigate and which cleaning modes are available?',
      answer:
        'An AI intelligent chip with an intelligent path-planning algorithm drives high-coverage cleaning with no missed corners. You can choose Automatic, N-path, Z-path or N+Z combined path modes, and it automatically returns to its starting point when finished. Smart memory also enables fixed-point spot cleaning.',
    },
    {
      question: 'Can I control it remotely?',
      answer:
        'Yes. The ShineBot C2 includes an infrared handheld remote and a smart app, so you can control, monitor and customise cleaning from your smartphone. The dual water spray is electronically controlled for automatic spraying — no frequent manual spraying required.',
    },
  ],
  related: [
    { label: 'All Window Robots', href: '/window-cleaning-robots' },
    { label: 'HygienX 300', href: '/products/hygienx-300' },
    { label: 'Robo Dressel Pool Robot', href: '/products/robo-dressel' },
    { label: 'LumineX 300', href: '/products/luminex-300' },
    { label: 'View All Products', href: '/#products' },
  ],
};

export default shineBotC2;
